let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("iYkn7")).then(() => parcelRequire('37dLP'));